/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import { Trans } from "react-i18next";
import styles from "./Footer.module.scss";
import { FlexGrid } from "../_common";
import { LanguageSelector } from "../starbreeze/LanguageSelector/LanguageSelector";
import { globalVar } from "utils/globalVar";

const publisherName = globalVar.JUSTICE_PUBLISHER_NAMESPACE.toUpperCase();

export default class Footer extends React.Component {
  getCurrentYear = () => {
    return new Date().getFullYear();
  };

  render() {
    return (
      <FlexGrid className={styles.footer} flexFlow="row" flex={0}>
        {/* SB-260 update footer style for Starbreeze: START */}
        <FlexGrid flex={1} className={styles.leftPanel} flexFlow="row">
          <div>
            <span>
              {/* // SA-1007 restyling localization selector: start */}
              <Trans i18nKey={"Starbreeze.Common.copyright"}>
                {{ publisherName }} Entertainment®" AND THE {{ publisherName }} LOGO, ARE REGISTERED TRADEMARKS OF{" "}
                {{ publisherName }} AB (PUBL). © {{ year: this.getCurrentYear() }} {{ publisherName }} AB (PUBL)
              </Trans>
              {/* // SA-1007 restyling localization selector: end */}
            </span>
          </div>
        </FlexGrid>
        <FlexGrid className={styles.rightPanel} flex={0}>
          <div>
            {/* // SA-1007 restyling localization selector: start */}
            <LanguageSelector />
            {/* // SA-1007 restyling localization selector: end */}
            <a href="/terms">
              <Trans i18nKey="Footer.tos">TERMS OF SERVICE</Trans>
            </a>
            <a href="/privacy">
              <Trans i18nKey="Footer.privacy">PRIVACY POLICY</Trans>
            </a>
            <a href="https://www.starbreeze.com/">WWW.STARBREEZE.COM</a>
          </div>
        </FlexGrid>
        {/* SB-260 update footer style for Starbreeze: END */}
      </FlexGrid>
    );
  }
}
